module.exports = __webpack_public_path__ + "static/pechuga-rellena-de-queso-panela-adobado-1-c9b7ed9f7c3c45fd12afaba9a907e2a4.jpg";